import type { ButtonHTMLAttributes } from "react";

export function PropertyChip({ className = "", ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button type="button" className={`inline-flex h-8 max-w-full items-center gap-1.5 rounded-full border border-border-strong bg-active/40 px-3 text-[12.5px] text-muted transition-colors hover:bg-hover hover:text-fg disabled:cursor-default disabled:opacity-50 ${className}`} {...props} />;
}
